<template>
  <div>
    <Header></Header>
    <Info></Info>
    <About></About>
    <Change></Change>
    <Rates></Rates>
    <Footer></Footer>
  </div>
</template>

<script>
'use strict';
import Header from '@/components/Header'
import Info from '@/components/Info'
import About from '@/components/About'
import Change from '@/components/Change'
import Rates from '@/components/Rates'
import Footer from '@/components/Footer'
export default {
  components: {
    Header, Info, About, Change, Rates, Footer
  }
}
</script>

<style lang="sass">

</style>